import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import { selectOrdersCreatedItem, selectOrdersQueryItems } from "../../../../redux/orders/selector";
import { useEffect, useState } from "react";
import { orders } from "../../../../redux/orders/action";
import PageLoader from "../../../../components/PageLoader";
import { currency } from "../../../../common/services/common.service";
import { leads } from "../../../../redux/leads/action";
import { quotes } from "../../../../redux/quotes/action";

const HomeOrderDetails = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const orderId = useSelector(selectOrdersCreatedItem)
    const orderDetails = useSelector(selectOrdersQueryItems)
    const orderData = orderDetails?.result?.items
    const [isLoading, setIsLoading] = useState<boolean>(false)
    
    const fetchOrderQueryById = async () => {
        await setIsLoading(true)
        await dispatch(orders.resetAction({ actionType: 'query' }))
        await dispatch(orders.query({
            url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/orders/query`, entity: 'order', jsonData: {

                Records: [
                    {
                        "Id": orderId?.result?.items[0]
                    }
                ]

            }
        }))
        await setIsLoading(false)
    }

    useEffect(
        () => {
            if (orderId?.result?.items.length > 0) {
                fetchOrderQueryById()
            }

        },
        [orderId]
    );
    const handleBack = async () => {
        localStorage.removeItem('access-token')
        localStorage.removeItem('accessTokenMetadata')
        localStorage.removeItem('userProfile')
        await dispatch(leads.resetAction({ actionType: 'create' }))
        await dispatch(quotes.resetAction({ actionType: 'create' }))
        await dispatch(orders.resetAction({ actionType: 'create' }))
        await navigate('/')
    }
    const handleLogin = async () => {
        localStorage.removeItem('access-token')
        localStorage.removeItem('accessTokenMetadata')
        localStorage.removeItem('userProfile')
        await dispatch(leads.resetAction({ actionType: 'create' }))
        await dispatch(quotes.resetAction({ actionType: 'create' }))
        await dispatch(orders.resetAction({ actionType: 'create' }))
        await navigate('/auth/login/customer')
    }
    return (
        <><div className="flex justify-end items-center px-8 py-4 bg-gray-50">
            <div className="flex items-center space-x-6">
                <button
                    onClick={handleBack}
                    className="text-primary font-semibold flex items-center space-x-1 hover:underline"
                >
                    <span className="text-lg">←</span>
                    <span>Back To Booking</span>
                </button>
                <div className="text-gray-600 font-semibold">
                    More details?{" "}
                    <button
                        onClick={handleLogin}
                        className="text-primary hover:underline"
                    >
                        Login
                    </button>
                </div>
            </div>
        </div>

            {isLoading ? <PageLoader /> :

                <div className="p-10">
                    <h2 className="uppercase font-bold mb-6 text-lg">Order Details</h2>
                    <h2 className="font-bold mb-6 text-base">Order Type: {orderData?.MobilityProductName}</h2>

                    <table className="min-w-full divide-y divide-gray-300 border border-gray-300 rounded-md">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Vehicle Number</th>
                                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Vehicle Chasis Number</th>
                                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Vehicle Brand</th>
                                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Vehicle Model</th>
                                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Vehicle Year</th>

                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {orderData?.MobilityOrderItems?.map((item: any, index: number) => (
                                <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                                    <td className="p-4 text-gray-700">{item?.VehicleNumber}</td>
                                    <td className="p-4 text-gray-700">{item?.VehicleChasisnumber}</td>
                                    <td className="p-4 text-gray-700">{item?.VehicleBrand}</td>
                                    <td className="p-4 text-gray-700">{item?.VehicleModel}</td>
                                    <td className="p-4 text-gray-700">{item.VehicleYear}</td>
                                </tr>
                            ))}
                            <tr className="bg-gray-200 font-semibold">
                                <td className="p-4" colSpan={3}>
                                    <div>Total Items: {orderData?.MobilityOrderItems.length}</div>
                                    <div>Total Price: {currency(orderData?.OrderTotal)}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="grid md:grid-cols-3 gap-4 pt-4">

                        <div className="bg-gray-50 p-4 border rounded-lg">
                            <h3 className="text-lg border-b pb-2 text-cyan-600 font-semibold">Billing Address</h3>
                            <div className="pt-2 text-gray-700">
                                <p>{orderData?.fulfillments[0]?.start?.location?.address?.name},</p>
                                <p>{orderData?.fulfillments[0]?.start?.location?.address?.locality},</p>
                                <p>{orderData?.fulfillments[0]?.start?.location?.address?.city} - {orderData?.fulfillments[0]?.start?.location?.address?.area_code},</p>
                                <p>{orderData?.fulfillments[0]?.start?.location?.address?.state},</p>
                                <p>{orderData?.fulfillments[0]?.start?.location?.address?.country}</p>
                                <p>Email: {orderData?.fulfillments[0]?.start?.customer?.email}</p>
                                <p>Phone: {orderData?.fulfillments[0]?.start?.customer?.phone}</p>
                            </div>
                        </div>
                        <div className="bg-gray-50 p-4 border rounded-lg">
                            <h3 className="text-lg border-b pb-2 text-cyan-600 font-semibold"> From Address</h3>
                            <div className="pt-2 text-gray-700">
                                <p>{orderData?.fulfillments[0]?.start?.location?.address?.name},</p>
                                <p>{orderData?.fulfillments[0]?.start?.location?.address?.locality},</p>
                                <p>{orderData?.fulfillments[0]?.start?.location?.address?.city} - {orderData?.fulfillments[0]?.start?.location?.address?.area_code},</p>
                                <p>{orderData?.fulfillments[0]?.start?.location?.address?.state},</p>
                                <p>{orderData?.fulfillments[0]?.start?.location?.address?.country}</p>
                                <p>Email: {orderData?.fulfillments[0]?.start?.customer?.email}</p>
                                <p>Phone: {orderData?.fulfillments[0]?.start?.customer?.phone}</p>
                            </div>
                        </div>
                        <div className="bg-gray-50 p-4 border rounded-lg">
                            <h3 className="text-lg border-b pb-2 text-cyan-600 font-semibold"> To Address</h3>
                            <div className="pt-2 text-gray-700">
                                <p>{orderData?.fulfillments[0]?.end?.location?.address?.name},</p>
                                <p>{orderData?.fulfillments[0]?.end?.location?.address?.locality},</p>
                                <p>{orderData?.fulfillments[0]?.end?.location?.address?.city} - {orderData?.fulfillments[0]?.end?.location?.address?.area_code},</p>
                                <p>{orderData?.fulfillments[0]?.end?.location?.address?.state},</p>
                                <p>{orderData?.fulfillments[0]?.end?.location?.address?.country}</p>
                                <p>Email: {orderData?.fulfillments[0]?.end?.customer?.email}</p>
                                <p>Phone: {orderData?.fulfillments[0]?.end?.customer?.phone}</p>
                            </div>
                        </div>
                    </div>


                </div>

            }

        </>

    );
};

export default HomeOrderDetails;